// // // src/pages/TermsOfServicePage.jsx
// // import { useNavigate, Link } from "react-router-dom";
// // import { useAuth } from "../hooks/useAuth";

// // export default function TermsOfServicePage() {
// //   const navigate = useNavigate();
// //   const { user } = useAuth();

// //   const lastUpdated = "May 10, 2025";
// //   const email = "support@smartaicareer.com";
// //   const appName = "ResumeScoreAI";
// //   const domain = "smartaicareer.com";
// //   const price = "$4.99";

// //   return (
// //     <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Inter', -apple-system, sans-serif" }}>

// //       {/* NAV */}
// //       <nav style={{ borderBottom: "1px solid #e2e8f0", padding: "0 5%", height: 64, display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", position: "sticky", top: 0, zIndex: 100 }}>
// //         <Link to="/" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
// //           <div style={{ width: 32, height: 32, background: "linear-gradient(135deg, #2563eb, #1d4ed8)", borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center" }}>
// //             <span style={{ color: "#fff", fontSize: 16, fontWeight: 700 }}>R</span>
// //           </div>
// //           <span style={{ fontWeight: 800, fontSize: 18, color: "#0f172a", letterSpacing: "-0.03em" }}>
// //             ResumeScore<span style={{ color: "#2563eb" }}>AI</span>
// //           </span>
// //         </Link>
// //         <button
// //           onClick={() => navigate(user ? "/dashboard" : "/")}
// //           style={{ padding: "8px 18px", background: "transparent", color: "#475569", border: "1px solid #e2e8f0", borderRadius: 8, fontWeight: 500, fontSize: 14, cursor: "pointer" }}
// //         >
// //           ← Back
// //         </button>
// //       </nav>

// //       {/* CONTENT */}
// //       <div style={{ maxWidth: 760, margin: "0 auto", padding: "48px 5% 80px" }}>

// //         {/* Header */}
// //         <div style={{ marginBottom: 40 }}>
// //           <div style={{ display: "inline-block", background: "#eff6ff", color: "#2563eb", fontSize: 12, fontWeight: 600, padding: "4px 12px", borderRadius: 20, marginBottom: 16, border: "1px solid #bfdbfe" }}>
// //             Legal
// //           </div>
// //           <h1 style={{ fontSize: "clamp(28px, 4vw, 40px)", fontWeight: 800, color: "#0f172a", marginBottom: 8, letterSpacing: "-0.02em" }}>
// //             Terms of Service
// //           </h1>
// //           <p style={{ fontSize: 14, color: "#64748b" }}>Last updated: {lastUpdated}</p>
// //         </div>

// //         {/* Intro */}
// //         <div style={{ background: "#eff6ff", borderLeft: "4px solid #2563eb", padding: "16px 20px", borderRadius: 8, marginBottom: 36, fontSize: 14, color: "#1e40af", lineHeight: 1.7 }}>
// //           By accessing or using {appName} at {domain}, you agree to be bound by these Terms of Service. Please read them carefully before using our service. If you do not agree, do not use the service.
// //         </div>

// //         <div style={{ display: "flex", flexDirection: "column", gap: 36 }}>

// //           <Section title="1. About the Service">
// //             <p>{appName} is an AI-powered resume analysis tool that provides ATS (Applicant Tracking System) scoring, keyword analysis, section feedback, and resume generation services to help job seekers improve their resumes.</p>
// //             <p>The service uses AI technology to analyze resumes and generate insights. Results are provided for informational purposes to help you improve your resume.</p>
// //             <p>The service is operated by an individual developer and is provided on an "as is" basis.</p>
// //           </Section>

// //           <Section title="2. Eligibility">
// //             <p>To use {appName} you must:</p>
// //             <ul>
// //               <li>Be at least 18 years of age (or the age of majority in your jurisdiction)</li>
// //               <li>Have the legal capacity to enter into a binding agreement</li>
// //               <li>Not be prohibited from using the service under applicable law</li>
// //               <li>Provide accurate and truthful information when creating an account</li>
// //             </ul>
// //           </Section>

// //           <Section title="3. Account Registration">
// //             <p>You must create an account to use our paid services. You are responsible for:</p>
// //             <ul>
// //               <li>Maintaining the confidentiality of your account credentials</li>
// //               <li>All activity that occurs under your account</li>
// //               <li>Notifying us immediately of any unauthorized access at <a href={`mailto:${email}`}>{email}</a></li>
// //             </ul>
// //             <p>We reserve the right to terminate accounts that violate these terms.</p>
// //           </Section>

// //           <Section title="4. Payments & Billing">
// //             <p>{appName} operates on a pay-per-use model:</p>
// //             <ul>
// //               <li>Each ATS resume analysis costs {price} (one-time payment)</li>
// //               <li>There are no subscriptions or recurring charges</li>
// //               <li>Payments are processed securely by Stripe</li>
// //               <li>You will be charged only when you choose to purchase an analysis</li>
// //               <li>All prices are in USD</li>
// //             </ul>
// //             <p>By completing a payment you authorize us to charge your payment method for the stated amount.</p>
// //           </Section>

// //           <Section title="5. Refund Policy">
// //             <p>Due to the digital and immediate nature of our service:</p>
// //             <ul>
// //               <li>Payments are generally <strong>non-refundable</strong> once an analysis has been generated</li>
// //               <li>If you experience a technical issue that prevents you from receiving your analysis, please contact us within 7 days at <a href={`mailto:${email}`}>{email}</a></li>
// //               <li>Refunds are evaluated on a case-by-case basis at our sole discretion</li>
// //               <li>If payment was taken but no analysis was delivered due to our error, a full refund will be issued</li>
// //             </ul>
// //           </Section>

// //           <Section title="6. Free Resume Generator">
// //             <p>Each completed paid ATS analysis unlocks one free AI-generated sample resume. Please note:</p>
// //             <ul>
// //               <li>Generated resumes are <strong>AI-created samples</strong> and may contain fictional information</li>
// //               <li>You must review and update all content with your real information before use</li>
// //               <li>We are not responsible for any outcomes resulting from using an unmodified AI-generated resume</li>
// //               <li>The free generation is tied to a single analysis and cannot be transferred</li>
// //             </ul>
// //           </Section>

// //           <Section title="7. Acceptable Use">
// //             <p>You agree not to use {appName} to:</p>
// //             <ul>
// //               <li>Upload content that is illegal, harmful, or violates the rights of others</li>
// //               <li>Attempt to reverse-engineer or extract our AI models or proprietary systems</li>
// //               <li>Use automated scripts or bots to access the service</li>
// //               <li>Attempt to circumvent payment systems or obtain services without payment</li>
// //               <li>Upload malware, viruses, or harmful code</li>
// //               <li>Violate any applicable local, national, or international laws</li>
// //             </ul>
// //           </Section>

// //           <Section title="8. Intellectual Property">
// //           <p><strong>Your content:</strong> You retain full ownership of your resume content and job descriptions that you submit. By using the service, you grant us a limited license to process your content solely to provide the analysis.</p>
// //             <p><strong>Our content:</strong> The {appName} platform, including its design, code, branding, and AI analysis outputs, is owned by us. You may not reproduce, distribute, or create derivative works without our written permission.</p>
// //             <p><strong>Generated resumes:</strong> AI-generated resume samples are provided for your personal use. You may edit and use them for job applications.</p>
// //             <p><strong>AI processing:</strong> Your resume content is processed by AI services solely to generate your analysis. We do not use your content to train AI models or share it with third parties for any other purpose.</p>
// //           </Section>

// //           <Section title="9. Disclaimer of Warranties">
// //             <p>{appName} is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that:</p>
// //             <ul>
// //               <li>The service will be uninterrupted, error-free, or secure</li>
// //               <li>ATS scores or analysis results are guaranteed to improve job application outcomes</li>
// //               <li>AI-generated resume content is accurate or suitable for your specific situation</li>
// //               <li>The service will meet your specific requirements</li>
// //             </ul>
// //             <p>Job application outcomes depend on many factors beyond our control.</p>
// //           </Section>

// //           <Section title="10. Limitation of Liability">
// //             <p>To the maximum extent permitted by law, {appName} and its operator shall not be liable for:</p>
// //             <ul>
// //               <li>Any indirect, incidental, special, or consequential damages</li>
// //               <li>Loss of employment opportunities or career outcomes</li>
// //               <li>Damages arising from use or inability to use the service</li>
// //               <li>Any errors or inaccuracies in AI-generated content</li>
// //             </ul>
// //             <p>Our total liability to you for any claim shall not exceed the amount you paid for the specific service giving rise to the claim.</p>
// //           </Section>

// //           <Section title="11. Privacy">
// //             <p>Your use of {appName} is also governed by our <Link to="/privacy" style={{ color: "#2563eb" }}>Privacy Policy</Link>, which is incorporated into these Terms by reference. Please review it to understand how we collect and use your information.</p>
// //           </Section>

// //           <Section title="12. Termination">
// //             <p>We reserve the right to suspend or terminate your account at any time if you violate these Terms. You may also delete your account at any time by contacting us. Upon termination:</p>
// //             <ul>
// //               <li>Your access to the service will be revoked</li>
// //               <li>Any unused paid analyses will be forfeited (no refund)</li>
// //               <li>Your data will be deleted per our Privacy Policy</li>
// //             </ul>
// //           </Section>

// //           <Section title="13. Changes to Terms">
// //             <p>We may update these Terms from time to time. We will notify you of material changes by posting the updated Terms on this page with a new date. Your continued use of the service after changes constitutes acceptance of the new Terms.</p>
// //           </Section>

// //           <Section title="14. Governing Law">
// //             <p>These Terms shall be governed by and construed in accordance with applicable laws. Any disputes arising from these Terms or your use of the service shall be resolved through good-faith negotiation. If unresolved, disputes shall be submitted to binding arbitration.</p>
// //           </Section>

// //           <Section title="15. Contact Us">
// //             <p>If you have questions about these Terms of Service, please contact us:</p>
// //             <div style={{ background: "#f8fafc", borderRadius: 10, padding: "16px 20px", marginTop: 12, border: "1px solid #e2e8f0" }}>
// //               <p style={{ margin: "4px 0", fontSize: 14, color: "#374151" }}><strong>{appName}</strong></p>
// //               <p style={{ margin: "4px 0", fontSize: 14, color: "#374151" }}>📧 <a href={`mailto:${email}`} style={{ color: "#2563eb" }}>{email}</a></p>
// //               <p style={{ margin: "4px 0", fontSize: 14, color: "#374151" }}>🌐 <a href={`https://${domain}`} style={{ color: "#2563eb" }}>{domain}</a></p>
// //             </div>
// //           </Section>

// //         </div>

// //         {/* Footer nav */}
// //         <div style={{ marginTop: 48, paddingTop: 24, borderTop: "1px solid #e2e8f0", display: "flex", gap: 16, flexWrap: "wrap" }}>
// //           <Link to="/privacy" style={{ fontSize: 14, color: "#2563eb", textDecoration: "none", fontWeight: 500 }}>Privacy Policy →</Link>
// //           <Link to="/support" style={{ fontSize: 14, color: "#2563eb", textDecoration: "none", fontWeight: 500 }}>Contact Support →</Link>
// //         </div>
// //       </div>

// //       {/* FOOTER */}
// //       <footer style={{ borderTop: "1px solid #e2e8f0", padding: "16px 5%", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fff", flexWrap: "wrap", gap: 8 }}>
// //         <span style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>ResumeScore<span style={{ color: "#2563eb" }}>AI</span></span>
// //         <span style={{ fontSize: 13, color: "#94a3b8" }}>© {new Date().getFullYear()} ResumeScoreAI. All rights reserved.</span>
// //       </footer>
// //     </div>
// //   );
// // }

// // // ── Reusable section component ──
// // function Section({ title, children }) {
// //   return (
// //     <div>
// //       <h2 style={{ fontSize: 18, fontWeight: 700, color: "#0f172a", marginBottom: 14, paddingBottom: 10, borderBottom: "1px solid #f1f5f9", letterSpacing: "-0.01em" }}>
// //         {title}
// //       </h2>
// //       <div style={{ fontSize: 14, color: "#475569", lineHeight: 1.8 }}>
// //         {children}
// //       </div>
// //       <style>{`
// //         div p { margin: 0 0 12px 0; }
// //         div ul { margin: 8px 0 12px 0; padding-left: 20px; }
// //         div ul li { margin-bottom: 6px; }
// //         div a { color: #2563eb; }
// //         div a:hover { text-decoration: underline; }
// //       `}</style>
// //     </div>
// //   );
// // }


// // new code
// // src/pages/TermsOfServicePage.jsx
// import { useNavigate, Link } from "react-router-dom";
// import { useAuth } from "../hooks/useAuth";

// export default function TermsOfServicePage() {
//   const navigate = useNavigate();
//   const { user } = useAuth();

//   const lastUpdated = "May 10, 2025";
//   const email = "support@smartaicareer.com";
//   const appName = "ResumeScoreAI";
//   const domain = "smartaicareer.com";
//   const price = "$4.99";

//   return (
//     <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Inter', -apple-system, sans-serif" }}>

//       {/* NAV */}
//       <nav style={{ borderBottom: "1px solid #e2e8f0", padding: "0 5%", height: 64, display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", position: "sticky", top: 0, zIndex: 100 }}>
//         <Link to="/" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
//           <div style={{ width: 32, height: 32, background: "linear-gradient(135deg, #2563eb, #1d4ed8)", borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center" }}>
//             <span style={{ color: "#fff", fontSize: 16, fontWeight: 700 }}>R</span>
//           </div>
//           <span style={{ fontWeight: 800, fontSize: 18, color: "#0f172a", letterSpacing: "-0.03em" }}>
//             ResumeScore<span style={{ color: "#2563eb" }}>AI</span>
//           </span>
//         </Link>
//         <button
//           onClick={() => navigate(user ? "/dashboard" : "/")}
//           style={{ padding: "8px 18px", background: "transparent", color: "#475569", border: "1px solid #e2e8f0", borderRadius: 8, fontWeight: 500, fontSize: 14, cursor: "pointer" }}
//         >
//           ← Back
//         </button>
//       </nav>

//       {/* CONTENT */}
//       <div style={{ maxWidth: 760, margin: "0 auto", padding: "48px 5% 80px" }}>

//         {/* Header */}
//         <div style={{ marginBottom: 40 }}>
//           <div style={{ display: "inline-block", background: "#eff6ff", color: "#2563eb", fontSize: 12, fontWeight: 600, padding: "4px 12px", borderRadius: 20, marginBottom: 16, border: "1px solid #bfdbfe" }}>
//             Legal
//           </div>
//           <h1 style={{ fontSize: "clamp(28px, 4vw, 40px)", fontWeight: 800, color: "#0f172a", marginBottom: 8, letterSpacing: "-0.02em" }}>
//             Terms of Service
//           </h1>
//           <p style={{ fontSize: 14, color: "#64748b" }}>Last updated: {lastUpdated}</p>
//         </div>

//         {/* Intro */}
//         <div style={{ background: "#eff6ff", borderLeft: "4px solid #2563eb", padding: "16px 20px", borderRadius: 8, marginBottom: 36, fontSize: 14, color: "#1e40af", lineHeight: 1.7 }}>
//           By accessing or using {appName} at {domain}, you agree to be bound by these Terms of Service. Please read them carefully before using our service. If you do not agree, do not use the service.
//         </div>

//         <div style={{ display: "flex", flexDirection: "column", gap: 36 }}>

//           <Section title="1. About the Service">
//             <p>{appName} is an AI-powered resume analysis tool that provides ATS (Applicant Tracking System) scoring, keyword analysis, section feedback, and resume generation services to help job seekers improve their resumes.</p>
//             <p>The service uses AI technology to analyze resumes and generate insights. Results are provided for informational purposes to help you improve your resume.</p>
//             <p>The service is operated by an individual developer and is provided on an "as is" basis.</p>
//           </Section>

//           <Section title="2. Eligibility">
//             <p>To use {appName} you must:</p>
//             <ul>
//               <li>Be at least 18 years of age (or the age of majority in your jurisdiction)</li>
//               <li>Have the legal capacity to enter into a binding agreement</li>
//               <li>Not be prohibited from using the service under applicable law</li>
//               <li>Provide accurate and truthful information when creating an account</li>
//             </ul>
//           </Section>

//           <Section title="3. Account Registration">
//             <p>You must create an account to use our paid services. You are responsible for:</p>
//             <ul>
//               <li>Maintaining the confidentiality of your account credentials</li>
//               <li>All activity that occurs under your account</li>
//               <li>Notifying us immediately of any unauthorized access at <a href={`mailto:${email}`}>{email}</a></li>
//             </ul>
//             <p>We reserve the right to terminate accounts that violate these terms.</p>
//           </Section>

//           <Section title="4. Payments & Billing">
//             <p>{appName} operates on a pay-per-use model:</p>
//             <ul>
//               <li>Each ATS resume analysis costs {price} (one-time payment)</li>
//               <li>There are no subscriptions or recurring charges</li>
//               <li>Payments are processed securely by Stripe</li>
//               <li>You will be charged only when you choose to purchase an analysis</li>
//               <li>All prices are in USD</li>
//             </ul>
//             <p>By completing a payment you authorize us to charge your payment method for the stated amount.</p>
//           </Section>

//           {/* ── Section 5: links out to dedicated refund page ── */}
//           <Section title="5. Refund Policy">
//             <p>
//               Please see our dedicated <Link to="/refund" style={{ color: "#2563eb" }}>Refund Policy</Link> for
//               full details on when refunds are available and how to request one.
//             </p>
//             <p>
//               In short: if something went wrong on our end, we refund you immediately. If you received
//               your analysis and results, payments are generally final. Contact us at{" "}
//               <a href={`mailto:${email}`}>{email}</a> within 7 days and we'll sort it out.
//             </p>
//           </Section>

//           <Section title="6. Free Resume Generator">
//             <p>Each completed paid ATS analysis unlocks one free AI-generated sample resume. Please note:</p>
//             <ul>
//               <li>Generated resumes are <strong>AI-created samples</strong> and may contain fictional information</li>
//               <li>You must review and update all content with your real information before use</li>
//               <li>We are not responsible for any outcomes resulting from using an unmodified AI-generated resume</li>
//               <li>The free generation is tied to a single analysis and cannot be transferred</li>
//             </ul>
//           </Section>

//           <Section title="7. Acceptable Use">
//             <p>You agree not to use {appName} to:</p>
//             <ul>
//               <li>Upload content that is illegal, harmful, or violates the rights of others</li>
//               <li>Attempt to reverse-engineer or extract our AI models or proprietary systems</li>
//               <li>Use automated scripts or bots to access the service</li>
//               <li>Attempt to circumvent payment systems or obtain services without payment</li>
//               <li>Upload malware, viruses, or harmful code</li>
//               <li>Violate any applicable local, national, or international laws</li>
//             </ul>
//           </Section>

//           <Section title="8. Intellectual Property">
//             <p><strong>Your content:</strong> You retain full ownership of your resume content and job descriptions that you submit. By using the service, you grant us a limited license to process your content solely to provide the analysis.</p>
//             <p><strong>Our content:</strong> The {appName} platform, including its design, code, branding, and AI analysis outputs, is owned by us. You may not reproduce, distribute, or create derivative works without our written permission.</p>
//             <p><strong>Generated resumes:</strong> AI-generated resume samples are provided for your personal use. You may edit and use them for job applications.</p>
//             <p><strong>AI processing:</strong> Your resume content is processed by AI services solely to generate your analysis. We do not use your content to train AI models or share it with third parties for any other purpose.</p>
//           </Section>

//           <Section title="9. Disclaimer of Warranties">
//             <p>{appName} is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that:</p>
//             <ul>
//               <li>The service will be uninterrupted, error-free, or secure</li>
//               <li>ATS scores or analysis results are guaranteed to improve job application outcomes</li>
//               <li>AI-generated resume content is accurate or suitable for your specific situation</li>
//               <li>The service will meet your specific requirements</li>
//             </ul>
//             <p>Job application outcomes depend on many factors beyond our control.</p>
//           </Section>

//           <Section title="10. Limitation of Liability">
//             <p>To the maximum extent permitted by law, {appName} and its operator shall not be liable for:</p>
//             <ul>
//               <li>Any indirect, incidental, special, or consequential damages</li>
//               <li>Loss of employment opportunities or career outcomes</li>
//               <li>Damages arising from use or inability to use the service</li>
//               <li>Any errors or inaccuracies in AI-generated content</li>
//             </ul>
//             <p>Our total liability to you for any claim shall not exceed the amount you paid for the specific service giving rise to the claim.</p>
//           </Section>

//           <Section title="11. Privacy">
//             <p>Your use of {appName} is also governed by our <Link to="/privacy" style={{ color: "#2563eb" }}>Privacy Policy</Link>, which is incorporated into these Terms by reference. Please review it to understand how we collect and use your information.</p>
//           </Section>

//           <Section title="12. Termination">
//             <p>We reserve the right to suspend or terminate your account at any time if you violate these Terms. You may also delete your account at any time by contacting us. Upon termination:</p>
//             <ul>
//               <li>Your access to the service will be revoked</li>
//               <li>Any unused paid analyses will be forfeited (no refund)</li>
//               <li>Your data will be deleted per our Privacy Policy</li>
//             </ul>
//           </Section>

//           <Section title="13. Changes to Terms">
//             <p>We may update these Terms from time to time. We will notify you of material changes by posting the updated Terms on this page with a new date. Your continued use of the service after changes constitutes acceptance of the new Terms.</p>
//           </Section>

//           <Section title="14. Governing Law">
//             <p>These Terms shall be governed by and construed in accordance with applicable laws. Any disputes arising from these Terms or your use of the service shall be resolved through good-faith negotiation. If unresolved, disputes shall be submitted to binding arbitration.</p>
//           </Section>

//           <Section title="15. Contact Us">
//             <p>If you have questions about these Terms of Service, please contact us:</p>
//             <div style={{ background: "#f8fafc", borderRadius: 10, padding: "16px 20px", marginTop: 12, border: "1px solid #e2e8f0" }}>
//               <p style={{ margin: "4px 0", fontSize: 14, color: "#374151" }}><strong>{appName}</strong></p>
//               <p style={{ margin: "4px 0", fontSize: 14, color: "#374151" }}>📧 <a href={`mailto:${email}`} style={{ color: "#2563eb" }}>{email}</a></p>
//               <p style={{ margin: "4px 0", fontSize: 14, color: "#374151" }}>🌐 <a href={`https://${domain}`} style={{ color: "#2563eb" }}>{domain}</a></p>
//             </div>
//           </Section>

//         </div>

//         {/* Footer nav — all three legal pages linked */}
//         <div style={{ marginTop: 48, paddingTop: 24, borderTop: "1px solid #e2e8f0", display: "flex", gap: 16, flexWrap: "wrap" }}>
//           <Link to="/privacy" style={{ fontSize: 14, color: "#2563eb", textDecoration: "none", fontWeight: 500 }}>Privacy Policy →</Link>
//           <Link to="/refund"  style={{ fontSize: 14, color: "#2563eb", textDecoration: "none", fontWeight: 500 }}>Refund Policy →</Link>
//           <Link to="/support" style={{ fontSize: 14, color: "#2563eb", textDecoration: "none", fontWeight: 500 }}>Contact Support →</Link>
//         </div>
//       </div>

//       {/* FOOTER */}
//       <footer style={{ borderTop: "1px solid #e2e8f0", padding: "16px 5%", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fff", flexWrap: "wrap", gap: 8 }}>
//         <span style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>ResumeScore<span style={{ color: "#2563eb" }}>AI</span></span>
//         <span style={{ fontSize: 13, color: "#94a3b8" }}>© {new Date().getFullYear()} ResumeScoreAI. All rights reserved.</span>
//       </footer>
//     </div>
//   );
// }

// // ── Reusable section component ──
// function Section({ title, children }) {
//   return (
//     <div>
//       <h2 style={{ fontSize: 18, fontWeight: 700, color: "#0f172a", marginBottom: 14, paddingBottom: 10, borderBottom: "1px solid #f1f5f9", letterSpacing: "-0.01em" }}>
//         {title}
//       </h2>
//       <div style={{ fontSize: 14, color: "#475569", lineHeight: 1.8 }}>
//         {children}
//       </div>
//       <style>{`
//         div p { margin: 0 0 12px 0; }
//         div ul { margin: 8px 0 12px 0; padding-left: 20px; }
//         div ul li { margin-bottom: 6px; }
//         div a { color: #2563eb; }
//         div a:hover { text-decoration: underline; }
//       `}</style>
//     </div>
//   );
// }

// src/pages/TermsOfServicePage.jsx
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function TermsOfServicePage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const lastUpdated = "May 28, 2025";
  const email       = "support@smartaicareer.com";
  const appName     = "ResumeScoreAI";
  const domain      = "smartaicareer.com";
  const price       = "$4.99";

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Inter', -apple-system, sans-serif" }}>

      {/* NAV */}
      <nav style={{ borderBottom: "1px solid #e2e8f0", padding: "0 5%", height: 64, display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", position: "sticky", top: 0, zIndex: 100 }}>
        <Link to="/" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
          <div style={{ width: 32, height: 32, background: "linear-gradient(135deg, #2563eb, #1d4ed8)", borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ color: "#fff", fontSize: 16, fontWeight: 700 }}>R</span>
          </div>
          <span style={{ fontWeight: 800, fontSize: 18, color: "#0f172a", letterSpacing: "-0.03em" }}>
            ResumeScore<span style={{ color: "#2563eb" }}>AI</span>
          </span>
        </Link>
        <button
          onClick={() => navigate(user ? "/dashboard" : "/")}
          style={{ padding: "8px 18px", background: "transparent", color: "#475569", border: "1px solid #e2e8f0", borderRadius: 8, fontWeight: 500, fontSize: 14, cursor: "pointer" }}
        >
          ← Back
        </button>
      </nav>

      {/* CONTENT */}
      <div style={{ maxWidth: 760, margin: "0 auto", padding: "48px 5% 80px" }}>

        <div style={{ marginBottom: 40 }}>
          <div style={{ display: "inline-block", background: "#eff6ff", color: "#2563eb", fontSize: 12, fontWeight: 600, padding: "4px 12px", borderRadius: 20, marginBottom: 16, border: "1px solid #bfdbfe" }}>
            Legal
          </div>
          <h1 style={{ fontSize: "clamp(28px, 4vw, 40px)", fontWeight: 800, color: "#0f172a", marginBottom: 8, letterSpacing: "-0.02em" }}>
            Terms of Service
          </h1>
          <p style={{ fontSize: 14, color: "#64748b" }}>Last updated: {lastUpdated}</p>
        </div>

        <div style={{ background: "#eff6ff", borderLeft: "4px solid #2563eb", padding: "16px 20px", borderRadius: 8, marginBottom: 36, fontSize: 14, color: "#1e40af", lineHeight: 1.7 }}>
          By accessing or using {appName} at {domain}, you agree to be bound by these Terms of Service. Please read them carefully before using our service. If you do not agree, do not use the service.
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 36 }}>

          <Section title="1. About the Service">
            <p>{appName} is an AI-powered resume analysis tool that provides ATS (Applicant Tracking System) scoring, keyword analysis, section feedback, and resume generation services to help job seekers improve their resumes.</p>
            <p>The service uses AI technology to analyze resumes and generate insights. Results are provided for informational and educational purposes only. {appName} is not a recruitment agency and does not guarantee employment, interviews, or any specific career outcome.</p>
            <p>The service is operated by an individual developer based in Washington State, USA, and is provided on an "as is" basis.</p>
          </Section>

          <Section title="2. Eligibility">
            <p>To use {appName} you must:</p>
            <ul>
              <li>Be at least 18 years of age (or the age of majority in your jurisdiction)</li>
              <li>Have the legal capacity to enter into a binding agreement</li>
              <li>Not be prohibited from using the service under applicable law</li>
              <li>Provide accurate and truthful information when creating an account</li>
            </ul>
            <p>This service is not directed at children under 13. We do not knowingly collect personal information from children under 13. If we become aware that a child under 13 has provided personal information, we will delete it immediately.</p>
          </Section>

          <Section title="3. Account Registration">
            <p>You must create an account to use our paid services. You are responsible for:</p>
            <ul>
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activity that occurs under your account</li>
              <li>Notifying us immediately of any unauthorized access at <a href={`mailto:${email}`}>{email}</a></li>
            </ul>
            <p>We reserve the right to terminate accounts that violate these terms.</p>
          </Section>

          <Section title="4. Payments & Billing">
            <p>{appName} operates on a pay-per-use model:</p>
            <ul>
              <li>Each ATS resume analysis package costs {price} (one-time payment)</li>
              <li>There are no subscriptions or recurring charges</li>
              <li>Payments are processed securely by Stripe — we never store your card details</li>
              <li>You will be charged only when you choose to purchase a package</li>
              <li>All prices are in USD</li>
              <li>Your total liability to us is limited to the amount actually paid for the specific service giving rise to any claim</li>
            </ul>
            <p>By completing a payment you authorize us to charge your payment method for the stated amount. The maximum amount you can ever be charged is the price displayed at checkout.</p>
          </Section>

          <Section title="5. Refund Policy">
            <p>
              Please see our dedicated <Link to="/refund" style={{ color: "#2563eb" }}>Refund Policy</Link> for
              full details on when refunds are available and how to request one.
            </p>
            <p>
              In short: if something went wrong on our end, we refund you immediately — no questions asked. If you received
              your analysis and results, payments are generally final. Contact us at{" "}
              <a href={`mailto:${email}`}>{email}</a> within 7 days and we will sort it out.
            </p>
          </Section>

          <Section title="6. AI-Generated Content Disclaimer">
            <p>Our service uses artificial intelligence to generate resume content, analysis, scores, and recommendations. You acknowledge and agree that:</p>
            <ul>
              <li>AI-generated content may contain <strong>errors, inaccuracies, or outdated information</strong></li>
              <li>ATS scores are <strong>simulations</strong> — they do not represent the exact score from any specific employer's ATS system</li>
              <li>Generated resumes are <strong>starting points only</strong> — you must review, personalise, and verify all content before using them in job applications</li>
              <li>Generated resumes may contain <strong>fictional company names, dates, and details</strong> — you must replace all fictional content with your real information</li>
              <li>We <strong>never guarantee</strong> that using our service will result in interviews, job offers, salary increases, or any specific career outcome</li>
              <li>Job application outcomes depend on many factors entirely beyond our control, including but not limited to: the employer's preferences, competition from other applicants, economic conditions, and the specific ATS system used</li>
              <li>AI recommendations are for <strong>informational purposes only</strong> and do not constitute professional career advice</li>
            </ul>
            <p>You use all AI-generated content entirely at your own risk. We expressly disclaim all liability for outcomes resulting from your use of AI-generated content.</p>
          </Section>

          <Section title="7. Acceptable Use">
            <p>You agree not to use {appName} to:</p>
            <ul>
              <li>Upload content that is illegal, harmful, or violates the rights of others</li>
              <li>Submit false, misleading, or fraudulent resume information</li>
              <li>Attempt to reverse-engineer or extract our AI models or proprietary systems</li>
              <li>Use automated scripts, bots, or scrapers to access the service</li>
              <li>Attempt to circumvent payment systems or obtain services without payment</li>
              <li>Upload malware, viruses, or harmful code</li>
              <li>Harass, threaten, or harm other users or our staff</li>
              <li>Violate any applicable local, national, or international laws</li>
            </ul>
            <p>We reserve the right to suspend or terminate your account immediately for violations of this section without refund.</p>
          </Section>

          <Section title="8. Intellectual Property">
            <p><strong>Your content:</strong> You retain full ownership of your resume content and job descriptions that you submit. By using the service, you grant us a limited, non-exclusive license to process your content solely to provide the analysis and generation services.</p>
            <p><strong>Our content:</strong> The {appName} platform, including its design, code, branding, scoring algorithms, and AI analysis outputs, is owned by us. You may not reproduce, distribute, or create derivative works without our written permission.</p>
            <p><strong>Generated resumes:</strong> AI-generated resume samples are provided for your personal, non-commercial use. You may edit and use them for your own job applications.</p>
            <p><strong>AI processing:</strong> Your resume content is processed by AI services solely to generate your analysis. We do not use your content to train AI models or share it with third parties for any purpose other than providing the service.</p>
          </Section>

          <Section title="9. Disclaimer of Warranties">
            <p>{appName} is provided "as is" and "as available" without warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement. We do not warrant that:</p>
            <ul>
              <li>The service will be uninterrupted, error-free, or secure at all times</li>
              <li>ATS scores or analysis results are accurate or will improve job application outcomes</li>
              <li>AI-generated resume content is accurate, complete, or suitable for your specific situation</li>
              <li>The service will meet your specific requirements or expectations</li>
              <li>Any errors in the service will be corrected within a specific timeframe</li>
            </ul>
            <p>Your use of the service is entirely at your own risk. Some jurisdictions do not allow the exclusion of implied warranties, so the above exclusions may not apply to you.</p>
          </Section>

          <Section title="10. Limitation of Liability">
            <p>To the maximum extent permitted by applicable law, {appName} and its operator shall not be liable for:</p>
            <ul>
              <li>Any indirect, incidental, special, consequential, or punitive damages</li>
              <li>Loss of employment opportunities, income, or career outcomes of any kind</li>
              <li>Damages arising from use or inability to use the service</li>
              <li>Any errors, inaccuracies, or omissions in AI-generated content</li>
              <li>Any unauthorized access to or use of our servers or your personal information</li>
              <li>Any interruption or cessation of transmission to or from our service</li>
            </ul>
            <p><strong>Our total cumulative liability to you for any and all claims arising from or related to your use of the service shall not exceed the total amount you actually paid us in the 12 months preceding the claim — in no event more than {price}.</strong></p>
            <p>Some jurisdictions do not allow the limitation of liability for consequential damages, so the above limitation may not apply to you.</p>
          </Section>

          <Section title="11. Indemnification">
            <p>You agree to defend, indemnify, and hold harmless {appName} and its operator from and against any claims, damages, obligations, losses, liabilities, costs, or expenses (including reasonable legal fees) arising from:</p>
            <ul>
              <li>Your use of and access to the service</li>
              <li>Your violation of any of these Terms</li>
              <li>Your violation of any third-party rights, including intellectual property or privacy rights</li>
              <li>Any content you submit to the service</li>
              <li>Any misrepresentation made by you in connection with the service</li>
            </ul>
            <p>This indemnification obligation will survive these Terms and your use of the service.</p>
          </Section>

          <Section title="12. Privacy">
            <p>Your use of {appName} is also governed by our <Link to="/privacy" style={{ color: "#2563eb" }}>Privacy Policy</Link>, which is incorporated into these Terms by reference. Please review it to understand how we collect, use, and protect your information.</p>
          </Section>

          <Section title="13. Termination">
            <p>We reserve the right to suspend or terminate your account at any time if you violate these Terms, without prior notice and without refund. You may also delete your account at any time by contacting us. Upon termination:</p>
            <ul>
              <li>Your access to the service will be immediately revoked</li>
              <li>Any unused paid services will be forfeited without refund</li>
              <li>Your data will be deleted per our Privacy Policy</li>
              <li>All provisions of these Terms that by their nature should survive termination shall survive</li>
            </ul>
          </Section>

          <Section title="14. Governing Law & Dispute Resolution">
            <p>These Terms shall be governed by and construed in accordance with the laws of the State of Washington, United States, without regard to its conflict of law provisions.</p>
            <p><strong>Informal resolution:</strong> Before filing any formal claim, you agree to contact us at <a href={`mailto:${email}`}>{email}</a> and attempt to resolve the dispute informally for at least 30 days.</p>
            <p><strong>Binding arbitration:</strong> If informal resolution fails, any dispute arising from these Terms or your use of the service shall be resolved through binding individual arbitration under the American Arbitration Association rules, conducted in Washington State.</p>
            <p><strong>Class action waiver:</strong> You waive any right to participate in a class action lawsuit or class-wide arbitration. All disputes must be brought in your individual capacity only.</p>
            <p><strong>Small claims:</strong> Nothing in this section prevents either party from bringing an individual action in small claims court for disputes within that court's jurisdiction.</p>
          </Section>

          <Section title="15. Force Majeure">
            <p>We will not be liable for any failure or delay in performance resulting from causes beyond our reasonable control, including but not limited to: acts of God, natural disasters, pandemic, war, terrorism, riots, government actions, internet or telecommunications failures, power outages, third-party service provider failures (including Stripe, Firebase, or Google), or any other event beyond our reasonable control.</p>
          </Section>

          <Section title="16. General Provisions">
            <p><strong>Severability:</strong> If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary, and the remaining provisions will remain in full force and effect.</p>
            <p><strong>Entire agreement:</strong> These Terms, together with the Privacy Policy and Refund Policy, constitute the entire agreement between you and {appName} regarding the service and supersede all prior agreements, communications, and understandings.</p>
            <p><strong>No waiver:</strong> Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. Any waiver must be in writing and signed by us.</p>
            <p><strong>Assignment:</strong> You may not assign or transfer these Terms or your rights under them without our prior written consent. We may assign our rights and obligations without restriction.</p>
            <p><strong>Headings:</strong> Section headings are for convenience only and have no legal or contractual effect.</p>
          </Section>

          <Section title="17. Changes to Terms">
            <p>We may update these Terms from time to time. We will notify you of material changes by posting the updated Terms on this page with a new "last updated" date. Your continued use of the service after changes are posted constitutes your acceptance of the revised Terms. If you do not agree to the revised Terms, you must stop using the service.</p>
          </Section>

          <Section title="18. Contact Us">
            <p>If you have questions about these Terms of Service, please contact us:</p>
            <div style={{ background: "#f8fafc", borderRadius: 10, padding: "16px 20px", marginTop: 12, border: "1px solid #e2e8f0" }}>
              <p style={{ margin: "4px 0", fontSize: 14, color: "#374151" }}><strong>{appName}</strong></p>
              <p style={{ margin: "4px 0", fontSize: 14, color: "#374151" }}>📧 <a href={`mailto:${email}`} style={{ color: "#2563eb" }}>{email}</a></p>
              <p style={{ margin: "4px 0", fontSize: 14, color: "#374151" }}>🌐 <a href={`https://${domain}`} style={{ color: "#2563eb" }}>{domain}</a></p>
              <p style={{ margin: "4px 0", fontSize: 13, color: "#64748b" }}>Washington State, United States</p>
            </div>
          </Section>

        </div>

        {/* Footer nav */}
        <div style={{ marginTop: 48, paddingTop: 24, borderTop: "1px solid #e2e8f0", display: "flex", gap: 16, flexWrap: "wrap" }}>
          <Link to="/privacy" style={{ fontSize: 14, color: "#2563eb", textDecoration: "none", fontWeight: 500 }}>Privacy Policy →</Link>
          <Link to="/refund"  style={{ fontSize: 14, color: "#2563eb", textDecoration: "none", fontWeight: 500 }}>Refund Policy →</Link>
          <Link to="/support" style={{ fontSize: 14, color: "#2563eb", textDecoration: "none", fontWeight: 500 }}>Contact Support →</Link>
        </div>
      </div>

      {/* FOOTER */}
      <footer style={{ borderTop: "1px solid #e2e8f0", padding: "16px 5%", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fff", flexWrap: "wrap", gap: 8 }}>
        <span style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>ResumeScore<span style={{ color: "#2563eb" }}>AI</span></span>
        <span style={{ fontSize: 13, color: "#94a3b8" }}>© {new Date().getFullYear()} ResumeScoreAI. All rights reserved.</span>
      </footer>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 700, color: "#0f172a", marginBottom: 14, paddingBottom: 10, borderBottom: "1px solid #f1f5f9", letterSpacing: "-0.01em" }}>
        {title}
      </h2>
      <div style={{ fontSize: 14, color: "#475569", lineHeight: 1.8 }}>
        {children}
      </div>
      <style>{`
        div p  { margin: 0 0 12px 0; }
        div ul { margin: 8px 0 12px 0; padding-left: 20px; }
        div ul li { margin-bottom: 6px; }
        div a  { color: #2563eb; }
        div a:hover { text-decoration: underline; }
      `}</style>
    </div>
  );
}
